/**
 * Promo banners on /company/: lift image skeleton after decode.
 *
 * @param {ParentNode} [root=document]
 */
export function initAboutBanners(root = document) {
  const images = root.querySelectorAll('.about-banners__media--skeleton .about-banners__image');

  images.forEach((img) => {
    if (!(img instanceof HTMLImageElement)) {
      return;
    }

    const media = img.closest('.about-banners__media');
    if (!(media instanceof HTMLElement)) {
      return;
    }

    const done = () => {
      media.classList.remove('about-banners__media--skeleton');
    };

    if (img.complete && img.naturalWidth > 0) {
      done();
      return;
    }

    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });
}
